import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Box,
} from '@mui/material';
import { Business } from '@mui/icons-material';
import { formatNipDisplay } from '../utils/gusData';

const GusFetchConfirmDialog = ({
  open,
  nip,
  onConfirm,
  onDecline,
  isLoading,
  error,
}) => (
  <Dialog open={open} onClose={isLoading ? undefined : onDecline} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
      <Business color="primary" />
      Pobierz dane z GUS?
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Dla NIP <strong>{formatNipDisplay(nip)}</strong> można automatycznie uzupełnić adres
        z rejestru GUS (bez nazwy firmy).
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onDecline} disabled={isLoading}>
        Nie
      </Button>
      <Button variant="contained" onClick={onConfirm} disabled={isLoading}>
        {isLoading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={16} color="inherit" />
            Pobieranie…
          </Box>
        ) : (
          'Tak, pobierz'
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

export default GusFetchConfirmDialog;
